// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
Rails.start();
import "@hotwired/turbo-rails"

const loadYoutubeEmbed = async () => {
  try {
    await import(
      'lite-youtube-embed/src/lite-yt-embed.js'
    );
  } catch (error) {
    console.error('Failed to load YouTube embed:', error);
  }
};
loadYoutubeEmbed();
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "./turbo_actions"

document.addEventListener("turbo:load", function() {
  var header = document.getElementById("header");

  document.addEventListener('scroll', function() {
    /*Apply classes for slide in bar*/
    if(window.scrollY < 10){
      header.classList.add("header-top");
      header.classList.remove("header-scroll");
    } else {
      header.classList.add("header-scroll");
      header.classList.remove("header-top");
    }
  });

  var anchorLinks = document.querySelectorAll("a[href^='#']");
  anchorLinks.forEach((anchorLink) => {
    anchorLink.addEventListener('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      if(anchorLink.getAttribute('href') != '#'){
        document.querySelector(anchorLink.getAttribute('href'))?.scrollIntoView({ behavior: 'smooth' });
      }
    });
  })

  if(window.location.hash) {
    var hash = window.location.hash;
    var element = document.querySelector(hash);
    if(element){
      window.scroll({top: 0, left: 0})
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  var scrollTop = document.getElementById("scrollTop");
  scrollTop.addEventListener('click', function(e) {
    e.stopPropagation();
    e.preventDefault();
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  });

  /*Toggle dropdown list*/
  /*https://gist.github.com/slavapas/593e8e50cf4cc16ac972afcbad4f70c8*/

  var navMenuDiv = document.getElementById("navContent");
  var navMenu = document.getElementById("navToggle");

  document.onclick = check;
  function check(e){
    var target = (e && e.target) || (event && event.srcElement);

    //Nav Menu
    if (!checkParent(target, navMenuDiv)) {
    // click NOT on the menu
    if (checkParent(target, navMenu)) {
      // click on the link
      if (navMenuDiv.classList.contains("hidden")) {
      navMenuDiv.classList.remove("hidden");
      } else {navMenuDiv.classList.add("hidden");}
    } else {
      // click both outside link and outside menu, hide menu
      navMenuDiv.classList.add("hidden");
    }
    }

  }
  function checkParent(t, elm) {
    while(t.parentNode) {
    if( t == elm ) {return true;}
    t = t.parentNode;
    }
    return false;
  }


  const SELECTOR = '.noUi-handle, #inviteBox';
  const ANIMATE_CLASS_NAME = 'animate__shakeY';

  const animate = element => (
    element.classList.add('animate__animated', ANIMATE_CLASS_NAME)
  );

  const isAnimated = element => (
    element.classList.contains('animate__animated', ANIMATE_CLASS_NAME)
  );

  const intersectionObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      // when element's is in viewport,
      // animate it!
      if (entry.intersectionRatio > 0) {
        animate(entry.target);
        // remove observer after animation
        observer.unobserve(entry.target);
      }
    });
  });

  setTimeout(function () {
    // get only these elements,
    // which are not animated yet
    const elements = [].filter.call(
      document.querySelectorAll(SELECTOR),
      element => !isAnimated(element, ANIMATE_CLASS_NAME),
    );

    // start observing your elements
    elements.forEach((element) => intersectionObserver.observe(element));
  }, 100)

});

import "./controllers"
